import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import tvaMq from "./tvaMq";
import "./ml";
import VueSVGIcon from "vue-svgicon";
import "vue-svgicon/dist/polyfill";
import SocialSharing from "vue-social-sharing";
import VueLazyload from "vue-lazyload";
import Router from "vue-router";
import VueLazyLoadVideo from "vue-lazyload-video";
import VueScrollTo from "vue-scrollto";
import store from "./store";
import VShowSlide from "v-show-slide";
import browserDetect from "vue-browser-detect-plugin";

Vue.config.productionTip = false;
Vue.use(VueSVGIcon);
Vue.use(SocialSharing);
Vue.use(VueLazyload);
Vue.use(VueLazyLoadVideo);
Vue.use(Router);
Vue.use(VueScrollTo);
Vue.use(tvaMq, {
  mobile: 720,
  tablet: 1024,
  desktop: Infinity,
  large: Infinity
});

Vue.use(VueScrollTo, {
  container: "#app",
  duration: 500,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});
Vue.use(VShowSlide);
Vue.use(browserDetect);

Vue.prototype.$menuHub = new Vue();
Vue.prototype.$retina = window.devicePixelRatio > 1;
Vue.prototype.$touchDevice = "ontouchstart" in document.documentElement;

new Vue({
  router,
  store,
  render: h => h(App),
  mounted: () => document.dispatchEvent(new Event("x-app-rendered"))
}).$mount("#app");
